import React, { FunctionComponent, SVGProps } from 'react';

export interface MastercardLogoProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const MastercardLogo: FunctionComponent<MastercardLogoProps> = ({
  className,
  ...props
}) => (
  <svg
    width="26"
    height="16"
    viewBox="0 0 26 16"
    className={className || ''}
    {...props}
  >
    <path
      fill="#ff5a00"
      d="M16.06,8c0-2.56-1.21-4.82-3.06-6.29-1.85,1.47-3.06,3.73-3.06,6.29s1.2,4.84,3.06,6.29c1.88-1.47,3.06-3.73,3.06-6.29Z"
    />
    <path
      fill="#eb001b"
      d="M9.94,8c0-2.56,1.21-4.82,3.06-6.29-1.36-1.07-3.08-1.71-4.96-1.71C3.6,0,0,3.58,0,8s3.6,8,8.04,8c1.88,0,3.6-.64,4.96-1.71-1.86-1.44-3.06-3.73-3.06-6.29Z"
    />
    <path
      fill="#f79e1b"
      d="M17.96,0c-1.88,0-3.6,.64-4.96,1.71,1.85,1.47,3.06,3.73,3.06,6.29s-1.18,4.82-3.06,6.29c1.36,1.07,3.08,1.71,4.96,1.71,4.44,0,8.04-3.58,8.04-8S22.4,0,17.96,0Z"
    />
  </svg>
);

export default MastercardLogo;
